export default "module.exports = (async () => {\n  // channel.\n})();"